import { AutoComplete } from "primereact/autocomplete";
import { useState } from "react";
import citiesData from "../cities/cities.json";

interface Option {
  value: string;
  label: string;
}
interface ModalProps {
  message: string; // Prop para el texto del placeholder
  titel: string;
  textButton: string;
  onClick: (city: string, code: string, data: any) => void; // Prop para la función
  cityData: any;
}

const ModalCity = ({
  message,
  titel,
  textButton,
  onClick,
  cityData,
}: ModalProps) => {
  const [value, setValue] = useState("");
  const [items, setItems] = useState<string[]>([]);
  const [ciudad, setCiudad] = useState("");
  const [ciudadCode, setCiudadCode] = useState("");
  const [errorOC, setErrorOC] = useState(false);

  const ciudadesArray: Option[] = Object.entries(citiesData).map(
    ([key, value]) => ({
      value: key,
      label: value,
    })
  );

  const search = (
    event: any,
    setItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    let data = ciudadesArray.filter((f) =>
      f.label.toUpperCase().startsWith(event.query.toUpperCase())
    );
    setItems([...data].map((item) => item.label));
  };

  //const [ciudadCode, setCiudadCode] = useState("");
  const citySet = (
    city: string,
    setCiudad: React.Dispatch<React.SetStateAction<string>>,
    setError: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    let data = ciudadesArray.filter((f) =>
      f.label.toUpperCase().startsWith(city.toUpperCase())
    );
    if (data.length < 1) {
      setError(true);
      setCiudad("");
      setCiudadCode("");
    } else {
      setError(false);
      setCiudad("");
      data.sort((a, b) => a.label.length - b.label.length);
      setCiudad(data[0].label);
      setCiudadCode(data[0].value);
    }
    if (data.length === 1) {
      setCiudad(data[0].label);
      setCiudadCode(data[0].value);
    }
  };

  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center w-96">
        <h2 className="text-2xl font-bold mb-4">{titel}</h2>
        <div>
          <div>{message}</div>
          <label
            htmlFor="dropdown-select"
            className="block font-medium text-gray-700"
          >
            Buscar
          </label>
          <AutoComplete
            className="w-64 mr-4"
            inputClassName="bg-gray-700 border border-gray-600 text-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 w-full"
            panelClassName="bg-gray-800 border border-gray-600 rounded-lg mt-1 shadow-md text-white dark:text-white"
            value={value}
            suggestions={items}
            completeMethod={(e) => search(e, setItems)}
            onChange={(e) => {
              setValue(e.value);
              citySet(e.value, setCiudad, setErrorOC);
            }}
            dropdown
            onSelect={(e) => {
              citySet(e.value, setCiudad, setErrorOC);
            }}
          />
          {errorOC ? (
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700 text-red-500"
            >
              Error Ciudad no encontrada
            </label>
          ) : (
            ""
          )}
        </div>
        <button
          onClick={() => {
            if (ciudad !== "" && !errorOC) {
              onClick(ciudad, ciudadCode, cityData);
            }
          }}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-3"
        >
          {textButton}
        </button>
      </div>
    </div>
  );
};

export default ModalCity;
